import { withStyles } from '@material-ui/styles';
import classnames from 'classnames';
import React, { useContext, useEffect, useState } from 'react';
import queryString from 'query-string';
import { getClientInvisionIQKpiGrid } from '../../services';
import { AppContext } from '../../AppContext';
import { withRouter } from 'react-router';
import { ConfirmationDialog } from '../../components/ConfirmationDialog';
import { Button } from '@material-ui/core';
import Loading from '../../components/Loading';
import VexcelGrid from '../../components/Orders/InvisionIQDashboard/VexcelGrid';
import BetterviewGrid from '../../components/Orders/InvisionIQDashboard/BetterviewGrid';

// Bringing in app version from Package.json
var { version: appVersion } = require('../../../package.json');

const styles = theme => ({
  main: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  customActionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  quickViewButton: {
    marginRight: 15,
  },
  loadingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

const InVisionIQKpiDetailPage = withRouter(
  withStyles(styles)(({ classes, match, location, history }) => {
    const {
      state: {},
    } = useContext(AppContext);

    const [gridLoading, setGridLoading] = useState(false);
    const [gridApi, setGridApi] = useState(null);
    const [gridData, setGridData] = useState();
    const [conversionOrders, setConversionOrders] = useState([]);
    const [virtualProvider, setVirtualProvider] = useState(null);

    const getGridData = async () => {
      try {
        const queryParams = queryString.parse(location.search);
        setGridLoading(true);
        const data = await getClientInvisionIQKpiGrid(queryParams);
        console.log({ data });
        setTimeout(() => {
          setGridData(data.results);
          setVirtualProvider(data.providerType);
        }, 0);
      } catch (error) {
        //
      } finally {
        setGridLoading(false);
      }
    };

    const handleHideConversionForm = () => {
      setConversionOrders([]);
      setTimeout(() => {
        getGridData();
      }, 0);
    };

    const handleOpenConversionForm = (data) => {
      let rows = gridApi?.getSelectedRows() ?? [data?.data];
      // if (!rows || rows.length === 0) {
      //   rows = Array.isArray(data?.data) ? data.data : data?.data ? [data.data] : [];
      // }
      console.log({ rows, data });
      setTimeout(() => {
        setConversionOrders(rows);
      }, 0);
    };

    const handleOnGridReady = ({ api }) => {
      setTimeout(() => {
        setGridApi(api);
      }, 0);
    };

    useEffect(() => {
      getGridData();
    }, []);

    return (
      <>
        <div className={classes.main}>
          <div
            className="flex-1 flex-column mb-10"
            style={{ position: 'relative', pointerEvents: gridLoading ? 'none' : 'auto' }}
          > 
          {virtualProvider === "VEXCEL" && (
            <VexcelGrid
              gridData={gridData}
              onGridReady={handleOnGridReady}
              gridApi={gridApi}
              conversionOrders={conversionOrders}
              onOpenConversionForm={handleOpenConversionForm}
              onHideConversionForm={handleHideConversionForm}
              customActionsContainer={classes.customActionsContainer}
            />
          )}
          {virtualProvider === "BETTERVIEW" && (
            <BetterviewGrid
              gridData={gridData}
              onGridReady={handleOnGridReady}
              gridApi={gridApi}
              conversionOrders={conversionOrders}
              onOpenConversionForm={handleOpenConversionForm}
              onHideConversionForm={handleHideConversionForm}
              customActionsContainer={classes.customActionsContainer}
            />
          )}

            {gridLoading && (
              <div className={classes.loadingOverlay}>
                <Loading size={75} />
              </div>
            )}
          </div>

          <div
            className={classnames('row-center-center', 'bg-white')}
            style={{ padding: 10, fontSize: 12, color: '#aaa' }}
          >
            Client Portal - Version {appVersion}
          </div>
        </div>
      </>
    );
  }),
);

export default InVisionIQKpiDetailPage;
